// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search-searchLoaderContainer-KPPHt {
	position: absolute;
	top: 30%;
	left: 0;
	right: 0;
}

.Search-searchResultContainer-Ep7pX {
	width: 100%;
	overflow-x: hidden;
	z-index: 0;
	padding-top: 176px;
	padding-bottom: 100px;
}

.Search-searchMapContainer-UPGbZ {
	width: 100%;
	position: fixed;
	right: 0;
	left: auto;
	bottom: 0;
	top: 177px;
}

.Search-mobileNavigation-Ommph {
	position: fixed;
	bottom: 13px;
	opacity: 1;
	text-align: center;
	-webkit-transition-duration: 250ms;
	        transition-duration: 250ms;
	-webkit-transition-property: opacity;
	transition-property: opacity;
	-webkit-transition-timing-function: ease-out;
	        transition-timing-function: ease-out;
	z-index: 5;
	left: 50%;
	-webkit-transform: translateX(-50%);
	    -ms-transform: translateX(-50%);
	        transform: translateX(-50%);
}

.Search-filterButton-PqEF9,
.Search-filterButton-PqEF9:hover,
.Search-filterButton-PqEF9:focus,
.Search-filterButton-PqEF9:active:focus {
	color: var(--common-primary-white-foreground);
	text-decoration: none;
	padding: 12px 24px;
	background-color: var(--common-black-primary-bg);
	-webkit-box-shadow: 0px 7px 9px var(--primary-box-shadow);
	        box-shadow: 0px 7px 9px var(--primary-box-shadow);
	border-radius: 24px;
	gap: 6px;
}

.Search-filterButtonIcons-kW2ai {
	width: 100%;
	max-width: 25px;
	height: 23px;
	min-width: 25px;
}

@media screen and (max-width: 1199px) {
	.Search-searchMapContainer-UPGbZ {
		display: block;
		width: 100%;
	}
}

@media screen and (min-width: 1200px) {
	.Search-searchMapContainerShow-AhKMw {
		display: block;
		width: 100% !important;
		padding: 24px 24px 24px 24px;
	}
}

@media screen and (max-width: 1199px) {
	.Search-searchMapContainer-UPGbZ {
		width: 100%;
		padding: 0px;
		top: 82px;
	}
}

@media screen and (max-width: 767px) {
	.Search-mobileNavigation-Ommph {
		bottom: 13px;
	}

	.Search-searchResultContainer-Ep7pX {
		padding-top: 263px;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/search/Search.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,QAAQ;CACR,UAAU;CACV,SAAS;CACT,UAAU;AACX;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,kCAA0B;SAA1B,0BAA0B;CAC1B,oCAA4B;CAA5B,4BAA4B;CAC5B,4CAAoC;SAApC,oCAAoC;CACpC,UAAU;CACV,SAAS;CACT,mCAA2B;KAA3B,+BAA2B;SAA3B,2BAA2B;AAC5B;;AAEA;;;;CAIC,6CAA6C;CAC7C,qBAAqB;CACrB,kBAAkB;CAClB,gDAAgD;CAChD,yDAAiD;SAAjD,iDAAiD;CACjD,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,eAAe;AAChB;;AAGA;CACC;EACC,cAAc;EACd,WAAW;CACZ;AACD;;AAEA;CACC;EACC,cAAc;EACd,sBAAsB;EACtB,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,SAAS;CACV;AACD;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,kBAAkB;CACnB;AACD","sourcesContent":[".searchLoaderContainer {\n\tposition: absolute;\n\ttop: 30%;\n\tleft: 0;\n\tright: 0;\n}\n\n.searchResultContainer {\n\twidth: 100%;\n\toverflow-x: hidden;\n\tz-index: 0;\n\tpadding-top: 176px;\n\tpadding-bottom: 100px;\n}\n\n.searchMapContainer {\n\twidth: 100%;\n\tposition: fixed;\n\tright: 0;\n\tleft: auto;\n\tbottom: 0;\n\ttop: 177px;\n}\n\n.mobileNavigation {\n\tposition: fixed;\n\tbottom: 13px;\n\topacity: 1;\n\ttext-align: center;\n\ttransition-duration: 250ms;\n\ttransition-property: opacity;\n\ttransition-timing-function: ease-out;\n\tz-index: 5;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n\n.filterButton,\n.filterButton:hover,\n.filterButton:focus,\n.filterButton:active:focus {\n\tcolor: var(--common-primary-white-foreground);\n\ttext-decoration: none;\n\tpadding: 12px 24px;\n\tbackground-color: var(--common-black-primary-bg);\n\tbox-shadow: 0px 7px 9px var(--primary-box-shadow);\n\tborder-radius: 24px;\n\tgap: 6px;\n}\n\n.filterButtonIcons {\n\twidth: 100%;\n\tmax-width: 25px;\n\theight: 23px;\n\tmin-width: 25px;\n}\n\n\n@media screen and (max-width: 1199px) {\n\t.searchMapContainer {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t}\n}\n\n@media screen and (min-width: 1200px) {\n\t.searchMapContainerShow {\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\tpadding: 24px 24px 24px 24px;\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.searchMapContainer {\n\t\twidth: 100%;\n\t\tpadding: 0px;\n\t\ttop: 82px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.mobileNavigation {\n\t\tbottom: 13px;\n\t}\n\n\t.searchResultContainer {\n\t\tpadding-top: 263px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchLoaderContainer": `Search-searchLoaderContainer-KPPHt`,
	"searchResultContainer": `Search-searchResultContainer-Ep7pX`,
	"searchMapContainer": `Search-searchMapContainer-UPGbZ`,
	"mobileNavigation": `Search-mobileNavigation-Ommph`,
	"filterButton": `Search-filterButton-PqEF9`,
	"filterButtonIcons": `Search-filterButtonIcons-kW2ai`,
	"searchMapContainerShow": `Search-searchMapContainerShow-AhKMw`
};
module.exports = ___CSS_LOADER_EXPORT___;
